import { Injectable, inject } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { DeclarationModel } from '../../cmg-1003/models';
import { SessionStore } from '../../core/state';
import { iStoreActions } from '../core/store-actions.interface';

export interface Cmg1003DeclarationsState extends EntityState<DeclarationModel, number> {
  selectedId: string;
}

function createInitialState(): Cmg1003DeclarationsState {
  return <Cmg1003DeclarationsState>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-declarations-store', idKey: 'borrowerId' })
export class Cmg1003DeclarationsStore extends EntityStore<Cmg1003DeclarationsState> implements iStoreActions<Cmg1003DeclarationsState> {
  private readonly _sessionStore = inject(SessionStore);

  private _initValue: DeclarationModel[] = [];
  constructor() {
    super(createInitialState());
  }

  override akitaPreAddEntity(declaration: DeclarationModel): DeclarationModel {
    this._initValue.push(JSON.parse(JSON.stringify(declaration)));
    return declaration;
  }

  override akitaPreUpdateEntity(_: Readonly<DeclarationModel>, nextEntity: any): DeclarationModel {
    this._sessionStore.update({ lastUpdatedDateTime: Date.now() });
    return nextEntity;
  }

  get initialValue() {
    return this._initValue;
  }
}
